import React, { useRef } from "react";
import styled, { css } from "styled-components";
import Menu from "components/bootstrap/Menu";
const ToggleDropdown = styled.span(
  ({ $alwaysShowCaret }) => css`
    cursor: pointer;

    ${$alwaysShowCaret ? "" : css`
          .caret {
            visibility: hidden;
          }

          &:hover .caret {
            visibility: visible;
          }
        `}
  `
);
const OverlayDropdown = ({
  alwaysShowCaret = false,
  children,
  closeOnSelect = true,
  dropdownZIndex = void 0,
  menuContainer = document.body,
  onClose,
  onToggle,
  placement = "bottom",
  show,
  toggleChild = "Toggle"
}) => {
  const toggleTarget = useRef();
  return /* @__PURE__ */ React.createElement(
    Menu,
    {
      opened: show,
      withinPortal: true,
      position: placement,
      closeOnItemClick: closeOnSelect,
      onClose,
      portalProps: { target: menuContainer },
      zIndex: dropdownZIndex
    },
    /* @__PURE__ */ React.createElement(Menu.Target, null, /* @__PURE__ */ React.createElement(ToggleDropdown, { $alwaysShowCaret: alwaysShowCaret, onClick: onToggle, ref: toggleTarget, role: "presentation" }, toggleChild)),
    /* @__PURE__ */ React.createElement(Menu.Dropdown, null, children)
  );
};
export default OverlayDropdown;
